import React from 'react';
import { useFormContext } from 'react-hook-form';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ControlledSelect from '@/components/common/form/ControlledSelect';
import translate from '@/lib/intl/translate';
import type CustomField from '@/types/api/CustomField';
import ConstituentField from '../../constants/ConstituentField';

function CustomFieldSelect({
  error,
  field,
  multiple,
}: {
  error?: boolean;
  field: CustomField;
  multiple?: boolean;
}) {
  const { control, watch } = useFormContext();
  const { customFieldId, fieldName, fieldOptions, isRequired } = field;
  const name = `${ConstituentField.CUSTOM_FIELDS}.${customFieldId}`;
  const fieldValue = watch(name);

  return (
    <FormControl className="w-full" size="small" error={error}>
      <InputLabel id={`${customFieldId}-label`} required={isRequired}>
        {fieldName}
      </InputLabel>
      <ControlledSelect
        defaultValue={multiple ? [] : ''}
        labelId={`${customFieldId}-label`}
        control={control}
        name={name}
        label={fieldName}
        multiple={multiple}
        required={isRequired}
        renderValue={(selected) => (
          <div className="max-w-full truncate">
            {Array.isArray(selected)
              ? selected.join(', ')
              : (selected as string)}
          </div>
        )}
        rules={
          isRequired ? { required: translate('FORMS_VALIDATION_REQUIRED') } : {}
        }
      >
        {!multiple && !isRequired && (
          <MenuItem className="text-text-secondary" value="">
            {translate('NONE')}
          </MenuItem>
        )}
        {fieldOptions?.map((value) => (
          <MenuItem key={value} value={value} className="flex items-center">
            {value}
            {multiple && (
              <Checkbox
                className="ml-auto"
                checked={fieldValue?.includes(value)}
              />
            )}
          </MenuItem>
        ))}
      </ControlledSelect>
    </FormControl>
  );
}

export default CustomFieldSelect;
